import { Route } from 'react-router-dom';
import { useMemo } from 'react';

import { Loader, RoutesInternal } from 'theSource/components';
import { FORM_FIELDS } from './utils';
import { ProfileDetailsPage } from './ProfileDetailsPage';
import { useEnrollmentProfileQuery } from 'enrollment/queries';
import { mapSubscriberModel } from 'theSource/utils';

export const Profile = () => {
  const { subscriber: data } = useEnrollmentProfileQuery({
    lumosEnabled: true,
  });

  const categories = useMemo(
    () => data && mapSubscriberModel(data, FORM_FIELDS),
    [data]
  );

  if (!categories) {
    return <Loader />;
  }

  return (
    <RoutesInternal>
      <Route
        path="/"
        element={<ProfileDetailsPage categories={categories!} />}
      />
    </RoutesInternal>
  );
};
